import React from 'react';

import RangeSlider from '../../Default/RangeSlider';
import RadioButton from '../../Default/RadioButton';
import { RotationBehaviour, RotationDirection } from '../../../../Game/Level/Blok/State';

export default function Rotation({ updateBlokStateSettings, rotationBehaviour, rotationSpeed, rotationAngle, rotationDirection }) {
    return (
        <div className="side-bar-page-content">
            <div className="side-bar-row">
                <RadioButton
                    name="rotationBehaviour"
                    value={RotationBehaviour.none}
                    activeValue={rotationBehaviour}
                    onChange={e =>
                        updateBlokStateSettings({
                            rotationBehaviour: parseInt(e.target.value, 10)
                        })
                    }
                >
                    Geen
                </RadioButton>
                <RadioButton
                    name="rotationBehaviour"
                    value={RotationBehaviour.free}
                    activeValue={rotationBehaviour}
                    onChange={e =>
                        updateBlokStateSettings({
                            rotationBehaviour: parseInt(e.target.value, 10)
                        })
                    }
                >
                    Vrij ronddraaien
                </RadioButton>
                <RadioButton
                    name="rotationBehaviour"
                    value={RotationBehaviour.continous}
                    activeValue={rotationBehaviour}
                    onChange={e =>
                        updateBlokStateSettings({
                            rotationBehaviour: parseInt(e.target.value, 10)
                        })
                    }
                >
                    Doorlopend
                </RadioButton>
                <RadioButton
                    name="rotationBehaviour"
                    value={RotationBehaviour.once}
                    activeValue={rotationBehaviour}
                    onChange={e =>
                        updateBlokStateSettings({
                            rotationBehaviour: parseInt(e.target.value, 10)
                        })
                    }
                >
                    Maar 1 keer
                </RadioButton>
                <RadioButton
                    name="rotationBehaviour"
                    value={RotationBehaviour.backAndForth}
                    activeValue={rotationBehaviour}
                    onChange={e =>
                        updateBlokStateSettings({
                            rotationBehaviour: parseInt(e.target.value, 10)
                        })
                    }
                >
                    Heen en weer
                </RadioButton>
            </div>
            <hr />
            <div className="side-bar-row side-bar-row-title">Tempo</div>
            <div className="side-bar-row" style={{ marginBottom: -5 }}>
                <RangeSlider
                    currentValue={rotationSpeed}
                    min={0}
                    max={100}
                    step={1}
                    sliderStep={5}
                    disabled={rotationBehaviour !== RotationBehaviour.continous && rotationBehaviour !== RotationBehaviour.once && rotationBehaviour !== RotationBehaviour.backAndForth}
                    onChange={v =>
                        updateBlokStateSettings({
                            rotationSpeed: v
                        })
                    }
                    valueOnSide
                />
            </div>
            <hr />
            <div className="side-bar-row side-bar-row-title">Draai hoek</div>
            <div className="side-bar-row" style={{ marginBottom: -5 }}>
                <RangeSlider
                    currentValue={rotationAngle}
                    min={0}
                    max={360}
                    step={1}
                    sliderStep={5}
                    disabled={rotationBehaviour !== RotationBehaviour.continous && rotationBehaviour !== RotationBehaviour.once && rotationBehaviour !== RotationBehaviour.backAndForth}
                    onChange={v =>
                        updateBlokStateSettings({
                            rotationAngle: v
                        })
                    }
                    valueOnSide
                />
            </div>
            <div className="side-bar-row side-bar-row-title">Draai richting</div>
            <div className="side-bar-row">
                <RadioButton
                    name="rotationDirection"
                    value={RotationDirection.left}
                    activeValue={rotationDirection}
                    onChange={e =>
                        updateBlokStateSettings({
                            rotationDirection: parseInt(e.target.value, 10)
                        })
                    }
                >
                    Linksom
                </RadioButton>
                <RadioButton
                    name="rotationDirection"
                    value={RotationDirection.right}
                    activeValue={rotationDirection}
                    onChange={e =>
                        updateBlokStateSettings({
                            rotationDirection: parseInt(e.target.value, 10)
                        })
                    }
                >
                    Rechtsom
                </RadioButton>
            </div>
        </div>
    );
}
